var map = {
	"./app_config.json": [
		80570,
		570
	],
	"./components_plan_page.json": [
		64073,
		4073
	],
	"./feedback.json": [
		44123,
		4123
	],
	"./reviews.json": [
		96424,
		6424
	],
	"./video_reviews.json": [
		42191,
		2191
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 52724;
module.exports = webpackAsyncContext;